module.exports = __webpack_public_path__ + "img/id-card-do.a7e0b651.png";